// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import ContentBox from 'components/ContentBox/ContentBox'

// Redux:
import { submitLogin } from 'actions/site'

class Attachments extends React.Component {
	handleLogin = ( e ) => {
		e.preventDefault()

		const form = e.currentTarget

		let username = this.lockUsername.value
		let password = this.lockPassword.value

		this.props.handleLogin( username, password )
	}

	render() {
		const { page, userIsLoggedIn, loginIsDisabled, loginIsProcessing, loginIsProcessed, loginError, loginSuccess, loginMessage } = this.props

		if ( ! page ) {
			return null
		}

		const attachmentsMarkup = page.attachments.map( ( e, i ) => {
			let icon = e.is_external_link ? 'icon-external-link' : 'icon-download'

			return (
				<li key={ i }>
					<a herf={ e.url } className="attachment">
						<i className={ icon } aria-hidden="true"></i>
						<span dangerouslySetInnerHTML={ { __html: e.title } } />
					</a>
				</li>
			)
		})

		const attachments = attachmentsMarkup.length ? (
			<div className="content-box page-section attachments-list">
				<div className="-heading">
					<h4>Download</h4>
				</div>

				<ul>
					{ attachmentsMarkup }
				</ul>
			</div>
		) : ''

		const protectedAttachmentsMarkup = page.protected_attachments.map( ( e, i ) => {
			let icon = e.is_external_link ? 'icon-external-link' : 'icon-download'

			return (
				<article className="tile" key={ i }>
					<ContentBox
						url={ e.url }
						headerIcon={ icon }
						footerTitle={ e.title }
						className="-with-link" />
				</article>
			)
		})

		const protectedAttachmentsClass = userIsLoggedIn ? '' : 'is-locked '
		const lockClass = userIsLoggedIn ? 'icon-unlock' : 'icon-lock'
		var formClass = ''
		formClass += loginIsProcessing ? ' is-processing' : ''
		formClass += loginIsProcessed ? ' is-processed' : ''
		formClass += loginError ? ' has-error is-unsuccessful' : ''
		formClass += loginSuccess ? ' is-successful' : ''

		const protectedAttachments = protectedAttachmentsMarkup.length ? (
			<div className={ protectedAttachmentsClass + 'attachments protected-attachments tiles' }>
				<div className="-area -col-12">
					<h2><i className={ lockClass + ' icon-inline' } aria-hidden="true"></i> Protected</h2>
				</div>

				{ userIsLoggedIn &&
					<div className="-area -col-12">
						{ protectedAttachmentsMarkup }
					</div>
				||
					<div className="-area -wrap -locked-container">
						<div className="-locked-wrap">
							<form className={ formClass } action="" onSubmit={ this.handleLogin }>
								<input type="text" placeholder="Email" ref={ ( e ) => { this.lockUsername = e } } />
								<input type="password" placeholder="Password" ref={ ( e ) => { this.lockPassword = e } } />

								<div className="-actions">
									{ loginIsDisabled &&
										<button className="button" disabled="disabled">Submit</button>
									||
										<button className="button">Submit</button>
									}

									<a className="-lost-password" href={ siteData.lostpassword_url }>Lost Password?</a>
								</div>
							</form>
						</div>
					</div>
				}
			</div>
		) : ''

		return (
			<div>
				{ attachments }
				{ protectedAttachments }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		userIsLoggedIn: state.site.userIsLoggedIn,
		loginIsDisabled: state.site.loginIsDisabled,
		loginIsProcessing: state.site.loginIsProcessing,
		loginIsProcessed: state.site.loginIsProcessed,
		loginError: state.site.loginError,
		loginSuccess: state.site.loginSuccess,
		loginMessage: state.site.loginMessage
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleLogin( username, password ) {
			dispatch( submitLogin( username, password ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Attachments )



// WEBPACK FOOTER //
// ./views/main/page/Attachments.jsx